<div class="flex flex-wrap items-center">
  <div>
    <a class="block whitespace-nowrap text-d text-theme-gray">
      <ng-container *ngIf="breadcrumbList[0].notTitleCase; else titleCase">
        {{ breadcrumbList[0].value | transloco }}
      </ng-container>

      <ng-template #titleCase>
        {{ breadcrumbList[0].value | transloco | titlecase }}
      </ng-template>
    </a>
  </div>

  <ng-container *ngFor="let item of breadcrumbList; let last = last; let first = first">
    <div *ngIf="!first" class="flex items-center ml-1 whitespace-nowrap">
      <span class="text-d text-theme-gray">/</span>
      <a class="text-d ml-1" [ngClass]="{ 'text-theme-dark': last, 'text-theme-gray': !last }">
        <ng-container *ngIf="item.notTitleCase; else titleCase">
          {{ item.value | transloco }}
        </ng-container>

        <ng-template #titleCase>
          {{ item.value | transloco | titlecase }}
        </ng-template>
      </a>
    </div>
  </ng-container>
</div>
